import React from 'react';
import './CapabilitiesSection.css';

function CapabilitiesSection() {
  const capabilities = [
    {
      title: 'U.S.-Registered Operations',
      description: 'Delaware registered wholesale trading company with established business infrastructure and operational credibility for B2B supplier partnerships.'
    },
    {
      title: 'Supplier Onboarding & Assessment',
      description: 'Professional vetting and onboarding process for qualified suppliers, including product evaluation, compliance review, and operational alignment.'
    },
    {
      title: 'Wholesale Purchasing',
      description: 'Direct wholesale product acquisition through established supplier networks, with focus on quality assurance and category fit.'
    },
    {
      title: 'Product Category Evaluation',
      description: 'Strategic assessment of consumer product categories for online retail distribution potential and market readiness.'
    },
    {
      title: 'U.S. Inventory Coordination',
      description: 'Coordination with domestic prep, storage, and fulfillment partners to manage inventory, quality control, and order preparation.'
    },
    {
      title: 'Online Retail Distribution',
      description: 'Distribution of selected product lines through established online retail and marketplace channels across the United States.'
    }
  ];

  return (
    <section id="wholesale-trading" className="capabilities-section">
      <div className="section-container">
        <div className="capabilities-header">
          <h2>Wholesale Trading & Distribution</h2>
          <p>
            U.S.-based wholesale trading company with established operational infrastructure 
            for supplier partnerships and online retail distribution.
          </p>
        </div>

        <div className="capabilities-grid">
          {capabilities.map((capability, index) => (
            <div key={index} className="capability-card">
              <h3>{capability.title}</h3>
              <p>{capability.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CapabilitiesSection;
